(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product__description"] && !Shopify.designMode) return;
  try {
    (function () {
    function setup(wrap) {
      var text = wrap.querySelector('[data-mp-desc]');
      var btn = wrap.querySelector('[data-mp-desc-toggle]');
      var label = wrap.querySelector('[data-mp-desc-label]');
      if (!text || !btn) return;

      function measure() {
        if (wrap.classList.contains('is-expanded')) return;
        wrap.removeAttribute('data-clamp');            // medir sin recorte
        var full = text.scrollHeight;
        wrap.setAttribute('data-clamp', '');           // aplicar recorte
        var clamped = text.clientHeight;
        // Si el texto entero cabe (más margen), no hace falta recortar ni botón
        if (full - clamped <= 4) {
          wrap.removeAttribute('data-clamp');
          btn.hidden = true;
        } else {
          btn.hidden = false;
        }
      }

      btn.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (label) label.textContent = expanded ? 'Leer menos' : 'Leer más';
      });

      measure();
      if (document.readyState !== 'complete') window.addEventListener('load', measure);
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 150); });
    }
    document.querySelectorAll('[data-mp-desc-wrap]').forEach(setup);
  })();
  } catch(e) { console.error(e); }
})();

})();
